import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  class: "text-align-center sticky-table-header",
  "data-excelautofilter": "",
  border: "1",
  cellpadding: "5",
  style: {"border-collapse":"collapse","border":"1px solid black","caption-side":"top","margin-right":"5px","width":"100%"}
}
const _hoisted_2 = { class: "border-bottom-tr print-repeat print-frozen-row" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { inject } from 'vue';

import {
  addFormatAndValAttributesFromLodash_getDataValue_helper,
  tableFormat,
} from '@/helpers/main_helper';

import { IPosition } from '@/types/IPosition';


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionsDetailTable',
  props: {
    positions: null,
    scales: null,
    paramKey: null,
    nextParamKey: null
  },
  setup(__props: any) {

const props = __props as {
  positions: IPosition[];
  scales: { [key: string]: { [key: string]: (v: number) => boolean } };
  paramKey: string;
  nextParamKey: string;
}



const getFullDate = inject('getFullDate') as (v: number) => string;

const COLUMNS: { [key: string]: any } = {
  time: {
    label: 'Дата',
    attrs: (val?: number) => ({
      'class': ['text-left'],
      'style': { minWidth: '140px' },
      'data-formatnum': 1,
      'data-excelalignh': 'left',
      'data-value': val
        ? addFormatAndValAttributesFromLodash_getDataValue_helper(1, val)[
            'data-value'
          ]
        : 'Дата',
      'data-minwidth': 37.5,
    }),
    format: (val: number) => `${getFullDate(val / 1000)}`,
  },
  rpm: {
    label: 'Обороты ДВС, (об/мин)',
    attrs: (val: number) => ({
      'class': [
        'text-center',
        {
          'font-weight-bold': props.scales[props.paramKey][props.nextParamKey](
            +val,
          ),
        },
      ],
      'data-formatnum': 12,
      'data-minwidth': 37.5,
    }),
    format: (val: number | null) => {
      if (val === null) {
        return '-';
      }
      return val;
    },
  },
  engntmpr: {
    label: 'Температура охлаждающей жидкости, (&#8451;)',
    attrs: (val: number) => ({
      'class': [
        'text-center',
        {
          'font-weight-bold': props.scales[props.paramKey][props.nextParamKey](
            +val,
          ),
        },
      ],
      'data-formatnum': 12,
      'data-minwidth': 41.5,
    }),
    format: (val: number | null) => {
      if (val === null || +val === -40) {
        return '-';
      }
      return val;
    },
  },
  hydroiltmpr: {
    label: 'Температура гидравлического масла, (%)',
    attrs: (val: number) => ({
      'class': [
        'text-center',
        {
          'font-weight-bold': props.scales[props.paramKey][props.nextParamKey](
            +val,
          ),
        },
      ],
      'data-formatnum': 11,
      'data-minwidth': 41.5,
    }),
    format: (val: number | null) => {
      if (val === null) {
        return '-';
      }
      return val;
    },
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.positions[0], (val, key, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (COLUMNS[key])
              ? (_openBlock(), _createElementBlock("th", _mergeProps({
                  key: 0,
                  class: "bg-grey-4"
                }, COLUMNS[key].attrs(), {
                  innerHTML: COLUMNS[key].label
                }), null, 16, _hoisted_3))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.positions, (pos, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pos, (val, key, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (COLUMNS[key])
                ? (_openBlock(), _createElementBlock("td", _normalizeProps(_mergeProps({ key: 0 }, COLUMNS[key].attrs(val))), [
                    _createElementVNode("div", {
                      innerHTML: _unref(tableFormat)(COLUMNS[key].format(val))
                    }, null, 8, _hoisted_4)
                  ], 16))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})